const AmplitudePort = {
  add: function (app, key) {
    if (key) {
      window.setupAmplitude(key);
    }

    app.ports.amplitudePortLogEvent.subscribe(function (event) {
      if (!window.amplitude) {
        return;
      }

      window.amplitude.getInstance().logEvent(event.type, event.payload);
    });

    app.ports.amplitudePortPropertiesEvent.subscribe(function (event) {
      if (!window.amplitude) {
        return;
      }

      window.amplitude.getInstance().setUserProperties(event.properties);
      app.ports.amplitudePortPropertiesSet.send(null);
    });
  },
};

module.exports = AmplitudePort;
